import React, { Component } from "react";
import { Button, Icon, Pagination } from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import DepartmentForm from "../../components/DepartmentForm";
import {
    getDepartmentList,
    addDepartment,
    updateDepartment,
    deleteDepartment
} from "../../core/actions/departmentAction";
import { exportFileAction } from "../../core/actions/commonAction";
import ProjectTable from "../../components/ProjectTable";
import CONSTANT from "../../core/constant/constant";

class Department extends Component {
    constructor() {
        super();
        this.state = {
            tableStructure: [
                {
                    label: "labels.id",
                    type: "id",
                    isClass: "first-col"
                },
                {
                    label: "labels.departmentCode",
                    type: "departmentCode",
                    isClass: "second-col",
                    sort: true
                },
                {
                    label: "labels.description",
                    type: "departmentName",
                    isClass: "last-col",
                    sort: true
                }
            ],
            paramList: {
                isSearch: 0,
                departmentCode: "",
                departmentName: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: "departmentCode-ASC"
            },
            department: {
                departmentCode: "",
                departmentName: ""
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            data: "",
            totalPage: 0,
            activePage: 1,
            disabled: true,
            errorCode: "",
            successCode: "",
            unSelectRow: false,
            isSearch: 0,
            btnDisable: false,
            exportDisabled: false,
            rowId: "",
            isAdded: false
        };
    }

    componentWillMount() {
        // Call API department-list, show list department
        this.props.getDepartmentList(this.state.paramList);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.departmentReducer.isLoading) {
            this.clearDepartment();
            if (this.state.isAdded === true) {
                this.getList();
            } else {
                this.props.getDepartmentList(this.state.paramList);
            }
        } else {
            let data = nextProps.departmentReducer.dataDepartment.departmentList;
            this.setState({
                data: data,
                totalPage: nextProps.departmentReducer.dataDepartment.totalPage,
                activePage: nextProps.departmentReducer.dataDepartment.currentPage || 1,
                btnDisable: false
            });

            // No data
            if (!data || (data && !data[0])) {
                this.setState({
                    errorCode: "018",
                    exportDisabled: true
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.departmentReducer.errorCode = "";
                    }.bind(this),
                    2000
                );

            } else {
                this.setState({
                    exportDisabled: false
                });
            }

            // Data have success code
            if (nextProps.departmentReducer.successCode) {
                this.setState({
                    successCode: nextProps.departmentReducer.successCode,
                });
                if (this.state.isAdded === true) {
                    this.clearParamList(false);
                }
                setTimeout(
                    function () {
                        this.setState({ successCode: "" });
                        nextProps.departmentReducer.successCode = ""
                    }.bind(this),
                    2000
                );
            }

            if (nextProps.departmentReducer.errorCode) {
                this.setState({
                    errorCode: nextProps.departmentReducer.errorCode,
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.departmentReducer.errorCode = "";
                    }.bind(this),
                    2000
                );
            }

        }
    }

    async getList() {
        let clrParam = await this.clearParamList(false);
        return this.props.getDepartmentList(this.state.paramList);       
    }

    // Event when click btn Search
    async searchDepartment() {
        this.clearError();
        this.setState({ btnDisable: true });
        const departmentCode = this.state.department.departmentCode;
        const departmentName = this.state.department.departmentName;

        await this.setState({
            paramList: {
                isSearch: 1,
                departmentCode: departmentCode,
                departmentName: departmentName,
                currentPage: 1,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy
            },
            disabled: true,
            unSelectRow: false,
            isSearch: 1,
            activePage: 1
        });

        return this.props.getDepartmentList(this.state.paramList);
    }

    // Event when click btn Add
    addDepartment = () => {
        if (!this.checkValidate()) return;
        
        this.setState({ btnDisable: true });
        const departmentCode = this.state.department.departmentCode;
        const departmentName = this.state.department.departmentName;

        this.setState({isAdded: true});
        return this.props.addDepartment({
            departmentCode: departmentCode,
            departmentName: departmentName
        });
    }

    // Event when click btn Update 
    updateDepartment = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        const departmentCode = this.state.department.departmentCode;
        const departmentName = this.state.department.departmentName;
        this.setState({isAdded: false});
        return this.props.updateDepartment({
            id: id,
            departmentCode: departmentCode,
            departmentName: departmentName
        });

    }

    // Delete department
    deleteDepartment = async () => {
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        this.clearDepartment();
       
        if (this.state.data.length === 1) {
            this.setState(prevState => ({
                paramList: {
                    ...prevState.paramList,
                    currentPage: 1
                }
            }));
        }
        this.setState({isAdded: false});
        return this.props.deleteDepartment({ id: id });
    }

    // Event when click btn Export
    departmentExportAction = () => {
        this.clearError();
        const exportParam = {
            departmentCode: this.state.paramList.departmentCode,
            departmentName: this.state.paramList.departmentName,
            sortBy: this.state.paramList.sortBy
        };
        this.props.exportFileAction(
            {
                urlGetkey: "Department/requestSecretKey",
                urlDownfile: "Department/departmentExport"
            },
            exportParam
        );
    }

    // Event when click clear department
    clearDepartment = () => {
        this.setState({
            department: {
                departmentCode: "",
                departmentName: ""
            },
            disabled: true,
            unSelectRow: false,
            rowId: "",
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear input error text
    clearError = () => {
        this.setState({
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear param list call API
    clearParamList = (isSort) => {

        this.setState({
            paramList: {
                isSearch: 0,
                departmentCode: "",
                departmentName: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: (isSort !== true) ? "departmentCode-ASC" : this.state.paramList.sortBy
            },
        });
    }

    // Handle on change input
    changeDepartment = evt => {
        const name = evt.target.name;
        const value = evt.target.value;
        this.setState(prevState => ({
            department: {
                ...prevState.department,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ''
                }
            }
        }));
        
    }

    // Event when click table row
    onRowClick = val => {
        this.clearError();
        let _department = {
            departmentCode: val.departmentCode !== null ? val.departmentCode : "",
            departmentName: val.departmentName !== null ? val.departmentName : ""
        };
        this.setState({
            disabled: false,
            department: _department,
            unSelectRow: true,
            rowId: val.id
        });
    }

    // Event when click sort table
    sortBy = async val => {
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                sortBy: val,
                rowId: val.id
            }
        }));
        this.props.getDepartmentList(this.state.paramList);
    }

    // Event when click btn pagination
    async handlePaginationChange(val) {
        await this.setState({
            activePage: val,
            paramList: {
                isSearch: this.state.isSearch,
                departmentCode: this.state.paramList.departmentCode,
                departmentName: this.state.paramList.departmentName,
                currentPage: val,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy
            }
        });

        return this.props.getDepartmentList(this.state.paramList);
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};

        (this.state.department.departmentCode.trim() === '') ? _formError['departmentCode'] = 'message.028' : _formError['departmentCode'] = '';

        (this.state.department.departmentName.trim() === '') ? _formError['departmentName'] = 'message.014' : _formError['departmentName'] = '';

        if (this.state.department.departmentCode.trim() !== '' && this.state.department.departmentName.trim() !== '') {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        } else {
            isValidate = false;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: _formError
                }
            }));
        }
        return isValidate;
    }

    render() {
        const { t } = this.props;
        const { activePage, errorCode, successCode, btnDisable} = this.state;
        return (
            <div>
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = "/employee" }, 500)}>
                        {t("navigation.master")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = "/employee" }, 500)}>
                        {t("navigation.employee")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location.reload() }, 500)}>
                        {t("navigation.department")}
                    </span>
                </h2>
                <div className="list-actions">
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.searchDepartment()}
                    >
                        <Icon name="search" />
                        {t("button.search")}
                    </Button>
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.addDepartment()}
                    >
                        <Icon name="add circle" />
                        {t("button.add")}
                    </Button>
                    <Button 
                    primary 
                    disabled={this.state.disabled} 
                    className="update-btn"
                    onClick={() => this.updateDepartment()}
                    >
                        <Icon name="edit" />
                        {t("button.update")}
                    </Button>
                    <Button
                        primary
                        disabled={this.state.disabled}
                        onClick={() => this.deleteDepartment()}
                        className="delete-btn"
                    >
                        <Icon name="trash alternate outline" />
                        {t("button.delete")}
                    </Button>
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.departmentExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.export")}
                    </Button>
                    <Button onClick={() => this.clearDepartment()}>
                        <Icon name="refresh" />
                        {t("button.clearAll")}
                    </Button>
                </div>
                <DepartmentForm
                    departmentData={this.state.department}
                    isError={this.state.inputSubmit.formError}
                    changeDepartment={input => this.changeDepartment(input)}
                />
                {successCode ? (
                    <div className="success-message list-error-message">
                        {t("message." + successCode)}
                    </div>
                ) : (
                        ""
                    )}    
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.state.data}
                    onRowClick={val => this.onRowClick(val)}
                    unSelectRow={this.state.unSelectRow}
                    defaultSort={this.state.paramList.sortBy}
                    sortBy={val => this.sortBy(val)}
                />
                <div className="table-paging">
                    {this.state.data && this.state.data[0] ? (
                        <Pagination
                            size="tiny"
                            activePage={activePage}
                            firstItem={null}
                            lastItem={null}
                            totalPages={this.state.totalPage}
                            prevItem={{
                                disabled: this.state.activePage == 1,
                                content: <Icon name="chevron left" />,
                                icon: true
                            }}
                            nextItem={{
                                disabled: this.state.activePage == this.state.totalPage,
                                content: <Icon name="chevron right" />,
                                icon: true
                            }}
                            onPageChange={(e, { activePage }) =>
                                this.handlePaginationChange(activePage)
                            }
                        />
                    ) : (
                            ""
                        )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getDepartmentList: opt => dispatch(getDepartmentList(opt)),
    addDepartment: opt => dispatch(addDepartment(opt)),
    updateDepartment: opt => dispatch(updateDepartment(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param)),
    deleteDepartment: opt => dispatch(deleteDepartment(opt))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(Department);
